<template>
  <div>
    <direct-upload-dropzone
      :on-file-added="handleFileAdded"
      :on-file-progress="handleFileProgress"
      :on-file-uploaded="handleFileUploaded"
      :accept="accept"
    >
      <div v-if="!doesFileExist" class="sf-btn">
        {{ btnTitle }}
      </div>
    </direct-upload-dropzone>
    <file-badge
      v-if="doesFileExist"
      :name="fileName"
      :progress="file.progress"
      :loading="file.loading"
      :file-size="fileSize"
      :on-remove="handleRemove"
    />
  </div>
</template>
<script setup lang="ts">
import { Blob as ActiveBlob } from '@rails/activestorage'
import { FileWithProgress } from './types'

import { computed, ref } from 'vue'
import fileBadge from './file-badge.vue'
import directUploadDropzone from './direct-upload-dropzone.vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SingleFileDirectUploader',
})

interface Props {
  btnTitle?: string
  onFileUploaded: (_file: FileWithProgress) => void
  accept?: string
}

const props = withDefaults(defineProps<Props>(), {
  btnTitle: '',
  accept: '',
})

const file = ref<FileWithProgress>({
  added: false,
  blob: null,
  file: null,
  loading: false,
  progress: '',
})

const doesFileExist = computed(() => file.value.added && file.value.file)
const fileName = computed(() => file.value.file?.name || '')
const fileSize = computed(() => file.value.file?.size || 0)

const handleFileUploaded = ({ blob }: { blob: ActiveBlob }) => {
  if (file.value.added) {
    file.value.blob = blob
    file.value.loading = false

    props.onFileUploaded(file.value)
  }
}

const handleFileAdded = ({ file: fileToAdd }: { file: File }) => {
  file.value.file = fileToAdd
  file.value.loading = true
  file.value.added = true
}

const handleFileProgress = ({ progress }: { progress: string }) => {
  if (file.value.added) {
    file.value.progress = progress
    file.value.loading = true
  }
}

const handleRemove = () => {
  file.value.added = false
  file.value.blob = null
  file.value.file = null
  file.value.loading = false
  file.value.progress = ''
}
</script>
